import React, { useState } from 'react';
import Popup from '../Popup';
import TextField from '../TextField';
import useApi from '../../hooks/useApi';

import { Container, Wrapper, TextBlock } from './styles';

const LoopClonePopup = ({ popupIsOpen, userToken, flash, onClose, loopId, defaultName, onSuccess, isSession }) => {
  const { postData, loading } = useApi(userToken);
  const [name, setName] = useState(i18n.__('session_circle_clone_name_placeholder', { name: defaultName }));
  const [disableButton, setDisableButton] = useState(false);

  const handleSave = async () => {
    try {
      const result = await postData(`/api/v3/circles/${loopId}/clone`, {
        name,
      });

      if (result.success) {
        setDisableButton(true);
        onSuccess(result.body);
      } else {
        if (result.code === 400) {
          throw new Error(i18n.__('invalid_email'));
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      flash(error.message ? error.message : i18n.__('app_error_alert'));
    }
  };

  const contentPanel = (
    <Container>
      <Wrapper>
        <TextBlock>{i18n.__('session_circle_clone_body')}</TextBlock>
        <>
          <TextField
            autoFocus
            id="name"
            name="name"
            label={i18n.__('session_circle_clone_name_label')}
            defaultValue={name}
            onChange={(event) => {
              setName(event.target.value);
            }}
          />
        </>
      </Wrapper>
    </Container>
  );

  return (
    <Popup
      popupIsOpen={popupIsOpen}
      heading={isSession ? i18n.__('session_circle_clone_header') : i18n.__('session_circle_clone_template_header')}
      id="loop-clone-popup"
      width={675}
      contentPanel={contentPanel}
      buttonLabel={i18n.__('app_copy')}
      onClose={onClose}
      onClick={handleSave}
      buttonDisabled={name.trim() === '' || loading || disableButton}
    />
  );
};

export default LoopClonePopup;
